import React from 'react'
import { ModalService } from 'services/ModalService'
import TransferMoneyModal from '@bet25/ui/TransferMoneyModal'
import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`

const WithdrawNotificationPopup = ({ data }) => {
    const handleCloseModal = () => {
        ModalService.closeModal()
    }

    return (
        <Wrapper>
            <TransferMoneyModal
                currentTheme={'dark'}
                amount={data.amount}
                closeModal={handleCloseModal}
            />
        </Wrapper>
    )
}

export default WithdrawNotificationPopup
